<template lang="html">
    <div class="newOrder">
    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>

    <div class="form-content">
        
        <div class="form-content-title">

        <div class="form-content-title-block form-title">

          <div class="form-title-block form-title-principal">

            <span>Herramientas para Publicaciones de Mercado Libre</span>

          </div>
          
          </div>
          <div class="form-group">
            <label > Codigo de Publicación:</label> 
            <div class="input-group">
                  <input type="text" aria-describedby="nameUSer" class="form-control null" v-model="publicationCode">
                  <b-button  class="btn btn-primary" v-on:click="verifiPubliCode()">Buscar</b-button>
            </div>
          </div>

          
     
      <div class="form-group" style="display : none" id="priceProduc">
            <div for="" class="float-left">Precio:</div> 
                  <span style="margin-left:5px">S/. {{this.producPrice}}</span>
                
      </div>
       <div class="form-group" style="display : none" id="titleProduc">
            <div for="" class="float-left"> Titulo del Producto:</div> 
                  <span style="margin-left:5px"> {{this.producTitle}}</span>
                
      </div>
      <div class="form-group">
            <label> Monto de rebate</label> 
            <div class="input-group">
                  <input type="number" aria-describedby="nameUSer" class="form-control null" v-model="montoRebate" >
                   </div>
      </div>
      <div class="form-group">
        <label > Intervalo de Fecha </label> 
        <div class="input-group">
        <input
        id="date"
          type="date"
          class='form-control login__input sen-form-input-with-tooltip'
          placeholder="Fecha de To de Rebate"
          onkeydown="return false"
          required
          v-model="dateTo"
        >
        <input
        id="date2"
          type="date"
          class='form-control login__input sen-form-input-with-tooltip ' 
          placeholder="Fecha de From de Rebate"
          onkeydown="return false"
          required
          v-model="datefrom"
        >
        </div>
         <div class="text-right">
           <p></p>
          <b-button  class="btn btn-primary" v-on:click="rebatePubli()"><i class="fas fa-check"></i>Aplicar</b-button>
        </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import axios from 'axios'
export default {
  components: { breadcrumb },
  data(){
        return {
          publicationCode:"",
          producPrice:"",
          producTitle:"",
          dateTo:"",
          datefrom:"",
          montoRebate:0,
          selectionUser: 'utils',  
          nameSection: 'Utils',
          listRoutes: [{ nameRoute: 'Utils', titleRoute: 'Utils' }],
    }
  },
  created(){
   
  },
  methods: {  
    verifiPubliCode(){
      axios.get(process.env.API_URL+"/api/meli/getItemDetails/electro/"+this.publicationCode)
    .then( response =>{
          this.producPrice=response.data.body.price
          this.producTitle=response.data.body.title
    });
    var pricePro=document.getElementById('priceProduc');
    var titlePro=document.getElementById('titleProduc');
    pricePro.style.display  = 'block';
    titlePro.style.display  = 'block';
    },
    rebatePubli(){
      if($("#date").val() < $("#date2").val())
          {
             axios.post(process.env.API_URL+"/api/rebate/create",{
            amount: parseInt(this.montoRebate,10),
            publication_code: this.publicationCode,
            from: this.datefrom,
            to: this.dateTo,
            active: 1,
            product_title:this.producTitle,
            product_price:this.producPrice

          })
          .then( response =>{
                console.log(response)
                if (response.data.status) {
                    window.history.go(-1)
                  }
          });
          }
        else{
            alert("La fecha de inicio no puede ser menor que la de fin")
        }
     
    }

  }
}
</script>
<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// UtilsAdmin.vue?f9ca7c08